import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { RulesService } from 'app/services/audit/rules.service';
import { RulesDtlService } from 'app/services/audit/rulesdtl.service';
import { Acm } from 'app/models/loyalty-acm.model';
import { AuditRuleObject, AuditRulesType } from 'app/views/audit/models/audit-event.model';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { ActivatedRoute } from '@angular/router';
import { AcmTypehasReason } from 'app/models/loyalty-acm-type.model';
@Component({
  selector: 'app-audit-action',
  templateUrl: './audit-action.component.html',
  styleUrls: ['./audit-action.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AuditActionComponent implements OnInit {

  @Input() ui_mode: string = this.rulesService.ui_modes.CREATE;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() readOnly: boolean = false;
  @Input() formSchema: any;
  @Input() auditRuleObject: AuditRuleObject;
  @Input() listReasonsFiltered: SelectItem[] = [];
  @Input() listReasonsFull: Array<AcmTypehasReason> = [];
  @Input() clusterOption: SelectItem[];
  @Input() clusterOptionActive: SelectItem[];
  @Input() acmList: SelectItem[];
  @Input() acmListFull: Array<Acm> ;
  @Input() listReasons: SelectItem[];
  @ViewChild('actionListTable') actionListTable: Campaign3KontableComponent;
  @Input() ruleId: number;
  @Input() isChallenge: boolean = false;
  actionsType: Array<AuditRulesType>;
  actionsTypeCombo: SelectItem[];
  @Output() conditionObjectChanged: EventEmitter<AuditRuleObject> = new EventEmitter<AuditRuleObject>();

  //elementi che regolano il p-selectButton
  stateOptions: any[];
  cities: any[];
  showAddNewAction: boolean;
  fieldModel = {
    customerpromo: "",
    promotype: "",
    generationCoupon: ""
  }
  hideGenerationCouponStatic: boolean = false;
  paginationType = Campaign3KontableComponent.ServerPagination;
  customFilter = Campaign3KontableComponent.CustomFilter;
  selectCustomFilter = Campaign3KontableComponent.CustomFilter;
  selectFilter = Campaign3KontableComponent.SelectFilter;
  disabled = {
    tutti: false,
    noloyalty: false
  }

  show = {
    warningAction: false,
    form: false,
    table: false
  }

  valid: boolean = true;
  auditRuleDtEditlId: number;
  //evento che volevo chiamare se la validazione fosse andata a buon termine
  @Output() validationResult: EventEmitter<boolean> = new EventEmitter<boolean>();
  ruleDtlId: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    public rulesService: RulesService,
    public rulesDtlService: RulesDtlService,
    private srvMessage: MessageService,
    private translate: TranslateService
  ) {

  }
  ngOnInit(): void {
    this.rulesDtlService.ruleId = this.ruleId;
    this.show.table = true;
    if(!this.ui_mode){
      this.ruleId = this.activatedRoute.snapshot.params['idRule'];
      if(!this.ruleId){
        this.ui_mode = this.rulesService.ui_modes.CREATE
      }
    }
    this.loadActionType();
     if (this.ui_mode == this.rulesService.ui_modes.EDIT) {
      this.loadRuleDetails();
    }

  }


  loadActionType() {
    this.rulesService.getActionTypeList().subscribe(res => {
      this.actionsTypeCombo = [];
      this.actionsType = [];
      if (res) {
        res.forEach(typeRule => {
          this.actionsTypeCombo.push({label: `${typeRule.description}` , value: typeRule.id })
          this.actionsType.push(typeRule);
        });
      }
    });
  }

  loadRuleDetails() {
    // this.table.filter.search.push({key: 'rule_id', value: this.auditRuleObject.rule.id, filterType: 'equals'});
    this.actionListTable.refresh();
    }
  performValidationAction(): boolean {
    this.valid = true;
    return this.valid;
  }

  openAddNewAction() {
    this.showAddNewAction = true;
  }

  closeAddNewAction(auditRuleObject: AuditRuleObject) {
    //caso in cui sto salvando la regola direttamente dal dettaglio, cioè facendo il salvataggio come ultimo step
    if(auditRuleObject && auditRuleObject.rule && auditRuleObject.rule.id){
      this.auditRuleObject = auditRuleObject;
      this.rulesDtlService.ruleId = auditRuleObject.rule.id;
      this.refreshAfterEdit() ;
    }
    this.showAddNewAction = false;
    this.auditRuleDtEditlId = null;
  }

  reloadRuleList(){
    console.log("reloadRuleList");
  }

  refreshAfterEdit() {
    var self = this;
    setTimeout(function () {
      self.actionListTable.refresh();
      self.showAddNewAction = false;
    }, 200);
  }

openEditAction(auditRuleDtlId: any) {
  this.auditRuleDtEditlId = auditRuleDtlId;
  this.showAddNewAction = true;
}

onRemoveRuleDtl(rowId: any) {
  this.rulesDtlService.deleteAuditRuleDtl(rowId).subscribe(res => {
    this.auditRuleObject.auditRuleDtl = this.auditRuleObject.auditRuleDtl.filter(f => f.id !== rowId);
    if (res) {
      this.srvMessage.add({
        severity: 'success',
        summary: this.translate.instant('common.success'), // Usa la traduzione per "Success"
        detail: this.translate.instant('audit.operation_successful')
      });
    this.actionListTable.refresh();
    }else{
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('audit.genericActionError')
      });
    }
  });
}

getActionDescription(row: any) {
  return row.audit_action_type_id.description;
}

isCustMovementRow(row: any): boolean {
  if (!this.actionsType) { return false; }
  const rawId = row.audit_action_type_id && row.audit_action_type_id.id
    ? row.audit_action_type_id.id
    : row.audit_action_type_id;
  const type = this.actionsType.find(t => t.id === rawId);
  return type != null && type.code === 'cust_movement';
}

onConditionObjectChanged(auditRuleObject: AuditRuleObject) {
  this.conditionObjectChanged.emit(auditRuleObject);
}


}



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-action/audit-action.component.ts